module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIAQMAAABvIyEEAAAABlBMVEUAAABVOYbFT/47AAAAAXRSTlMAQObYZgAAAEJJREFUeF61xoEJwDAUQkE3cKFC99/GAQJWMkCF8PMEOdSebEwCbeernNzFLR0KxpzoLasojIKudFngwitcFTV5/313TQsi1JsBHwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f47e.png
// module id = 949
// module chunks = 0